import React from 'react';
import Cookies from 'js-cookie';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import './login.css';

import { LoginPasswordResetRequestForm } from './LoginPasswordResetRequestForm';
import { LoginResetPasswordForm } from './LoginResetPasswordForm';
import { LoginForcedPasswordChangeForm } from './LoginForcedPasswordChangeForm';
import { Timeout, ApiDomainUrl } from './utils/Common';
import { Button } from 'reactstrap';
import Logo1 from '../images/logo1.png';

class Login extends React.Component {
  constructor(props) {
    super(props);

    localStorage.removeItem('user');

    this.state = {
      email: '',
      password: '',
      new_password: '',
      confirm_password: '',
      reset_code: '',
      errMsg: '',
      reset_email: '',
      isLogin: Cookies.get('user') !== undefined ? true : false,
      forgotPasswordModal: false,
      forcePasswordChangeModal: false,
      challengeSession: '',
      passwordChangeModal: false,
      passwordVisible: false,
      newPasswordVisible: false,
      showPasswordLogin: true,
      isMagicLinkLoading: false,
      magicLinkMessage: '',
      magicLinkMessageType: '',
      errorMessage: '',
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePasswordResetRequest =
      this.handlePasswordResetRequest.bind(this);
    this.setForgotPasswordModal = this.setForgotPasswordModal.bind(this);
    this.setResetPasswordModal = this.setResetPasswordModal.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    // this.handleNewPasswordRequest = this.handleNewPasswordRequest.bind(this);
    this.handleNewPasswordChallenge = this.handleNewPasswordChallenge.bind(this);
    this.startSession = this.startSession.bind(this);
    this.setForcePasswordChangeModal =
      this.setForcePasswordChangeModal.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.setPasswordVisible = this.setPasswordVisible.bind(this);
    this.setNewPasswordVisible = this.setNewPasswordVisible.bind(this);
    this.handleResetModel = this.handleResetModel.bind(this);
    this.handleMagicLinkRequest = this.handleMagicLinkRequest.bind(this);
    this.handleMagicLinkLogin = this.handleMagicLinkLogin.bind(this);
    this.getMagicLinkTokenFromUrl = this.getMagicLinkTokenFromUrl.bind(this);
    this.handlePasswordlessMode = this.handlePasswordlessMode.bind(this);

    this.newEmailRef = React.createRef();
  }

  componentDidMount() {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';

    setTimeout(() => {
      if (this.newEmailRef.current) {
        this.newEmailRef.current.focus();
      }
    }, 100);

    const token = this.getMagicLinkTokenFromUrl();
    if (token) {
      this.handleMagicLinkLogin(token);
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = '';
  }

  getMagicLinkTokenFromUrl() {
    const href = window.location.href || '';

    try {
      const url = new URL(href);
      const directToken = url.searchParams.get('token');
      if (directToken) {
        return directToken;
      }
    } catch (error) {}

    const tokenMatch = href.match(/[?&]token=([^&#]+)/i);
    return tokenMatch ? decodeURIComponent(tokenMatch[1]) : '';
  }

  async handleMagicLinkLogin(token) {
    this.setState({
      isMagicLinkLoading: true,
      magicLinkMessage: 'Signing you in with magic link...',
      magicLinkMessageType: 'success',
    });

    try {
      const response = await fetch(ApiDomainUrl() + '/login/magiclink/verify', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Token: token }),
      });

      const result = await response.json().catch(() => ({}));

      if (response.ok && result?.message === 'Ok' && result?.data?.token) {
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        this.startSession(result.data);
        return;
      }

      this.setState({
        magicLinkMessage:
          result?.message ||
          'Magic link is invalid or expired. Please request a new one.',
        magicLinkMessageType: 'danger',
      });
    } catch (error) {
      this.setState({
        magicLinkMessage:
          'Unable to complete magic link sign-in right now. Please try again.',
        magicLinkMessageType: 'danger',
      });
    } finally {
      this.setState({ isMagicLinkLoading: false });
    }
  }

  handlePasswordlessMode() {
    this.setState({
      showPasswordLogin: false,
      password: '',
      passwordVisible: false,
      errMsg: '',
      magicLinkMessage: '',
      magicLinkMessageType: '',
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * Stores the signed-in user and reloads so App re-reads the cookie and routes into the portal.
   * Shared by every way in - password, magic link, and the Cognito new-password challenge - so a
   * session started one way carries the same claims as one started any other. Dropping repid or
   * clientid here would strand a rep or client on a portal that cannot find their records.
   * @param data - The data object from an authentication response
   */
  startSession(data) {
    Cookies.set(
      'user',
      JSON.stringify({
        userid: data.id,
        firstname: data.firstName,
        lastname: data.lastName,
        email: data.usernameEmail,
        token: data.token,
        userrolename: data.userRoleName,
        intid: data.intId,
        repid: data.repId,
        clientid: data.clientId,
      }),
      { expires: 3 }
    );

    window.location.reload();
  }

  async handleMagicLinkRequest() {
    const email = (this.state.email || '').trim();

    if (!email) {
      this.setState({
        magicLinkMessage: 'Enter your email first.',
        magicLinkMessageType: 'danger',
      });
      return;
    }

    this.setState({
      isMagicLinkLoading: true,
      magicLinkMessage: '',
      magicLinkMessageType: '',
    });

    try {
      const response = await fetch(ApiDomainUrl() + '/login/magiclink/request', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Email: email }),
      });

      const payload = await response.json().catch(() => ({}));
      const message = payload?.message ||
        (response.ok
          ? 'If the email exists, a magic link has been sent.'
          : 'Unable to request a magic link right now.');

      this.setState({
        magicLinkMessage: message,
        magicLinkMessageType: response.ok ? 'success' : 'danger',
      });
    } catch (error) {
      this.setState({
        magicLinkMessage: 'Unable to request a magic link right now.',
        magicLinkMessageType: 'danger',
      });
    } finally {
      this.setState({ isMagicLinkLoading: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.state.email || !this.state.password) {
      this.setState({ errMsg: 'Email and password are required.' });
      return;
    }

    let data = {
      Email: this.state.email.trim(),
      Password: this.state.password,
    };
    fetch(ApiDomainUrl() + '/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.message === 'NEW_PASSWORD_REQUIRED') {
            this.setState({
              forcePasswordChangeModal: true,
              challengeSession: result.data?.challengeSession || '',
            });
          } else if (result.message === 'Ok') {
            this.startSession(result.data);
          } else {
            this.setState({ errMsg: result.message, isLogin: false });
          }
        },
        (error) => {}
      );
  }

  handleNewPasswordChallenge = async (username, newPassword) => {
    const data = {
      Username: username,
      Session: this.state.challengeSession,
      NewPassword: newPassword,
    };

    try {
      const response = await fetch(ApiDomainUrl() + '/login/newpassword', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok && result?.message === 'Ok' && result?.data?.token) {
        this.startSession(result.data);
      } else {
        this.handleSaveEventSuccess({
          message: result?.message || 'Password change failed. Please try again.',
          color: 'warning',
        });
      }
    } catch (error) {
      return;
    }
  };

  async handlePasswordResetRequest() {
    const data = {
      Username: this.state.reset_email,
    };

    try {
      const res = await fetch(ApiDomainUrl() + '/forgotpassword', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      // Safely parse JSON; if body is empty or invalid, fallback to {}
      const payload = await res.json().catch(() => ({}));

      if (res.ok) {
        // Close request modal, open reset modal, and show success message
        this.setForgotPasswordModal(false);
        this.setResetPasswordModal(true);
        // this.handleSaveEventSuccess({
        //   message: payload?.message || 'Password reset initiated successfully',
        //   color: 'success',
        // });
      } else {
        // Show server-provided message when available; otherwise a generic one
        const msg =
          payload?.responseMetadata?.metadata?.ErrorMessage ||
          payload?.message ||
          'Unable to initiate password reset';
        this.handleSaveEventSuccess({ message: msg, color: 'warning' });
      }
    } catch (error) {
      // Network or unexpected error
      this.handleSaveEventSuccess({
        message: 'An error occurred while attempting to reset the password.',
        color: 'warning',
      });
    }
  }

  async handleResetPassword() {
    const { reset_code, new_password, confirm_password } = this.state;

    if (new_password !== confirm_password) {
      alert('Passwords do not match');
      return;
    }

    let model = {
      Username: this.state.reset_email,
      ConfirmationCode: reset_code,
      NewPassword: new_password,
    };

    try {
      const response = await fetch(ApiDomainUrl() + '/confirmpassword', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(model),
      });

      if (response.ok) {
        // Show popup notification
        window.alert(
          'Password has been reset successfully! You can now log in with your new password.'
        );

        this.handleSaveEventSuccess({
          message: 'Password changed successfully',
          color: 'success',
        });
        this.setState({
          reset_email: '',
          reset_code: '',
          new_password: '',
          confirm_password: '',
          passwordVisible: false,
        });
        this.setResetPasswordModal(false);
      } else {
        const errorData = await response.json();
        this.handleSaveEventSuccess({
          message: errorData.message,
          color: 'warning',
        });
      }
    } catch (error) {
      this.handleSaveEventSuccess({
        message: 'Error changing password',
        color: 'warning',
      });
    }
  }

  setForgotPasswordModal(show) {
    this.setState({ forgotPasswordModal: show });
    this.setState({ password: '' });
  }

  setResetPasswordModal(show) {
    this.setState({ resetPasswordModal: show });
    this.setState({ password: '' });
  }

  setForcePasswordChangeModal(show) {
    this.setState({ forcePasswordChangeModal: show });
    this.setState({ password: '' });
  }

  setPasswordVisible(show) {
    this.setState({ passwordVisible: show });
  }

  setNewPasswordVisible(show) {
    this.setState({ newPasswordVisible: show });
  }

  handleResetModel() {
    this.setState({
      reset_email: '',
      reset_code: '',
      new_password: '',
      confirm_password: '',
      passwordVisible: false,
    });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  render() {
    const { isLogin } = this.state;
    return (
      <div className="login-page">
        <header className="login-header">
          <div className="login-logo-wrap">
            <img
              className="login-logo-image"
              src={Logo1}
              alt="Executive Linguist Agency, Inc."
            />
          </div>
        </header>
        {isLogin === false && (
          <div className="card card-container">
            {/* <center>
                            <Alert color={this.state.alert.color} isOpen={this.state.alert.isOpen}>
                                {this.state.alert.message}
                            </Alert>
                        </center> */}
            <img
              className="profile-img-card"
              src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
              alt="FatCat"
            />
            <p className="profile-name-card" id="profile-name"></p>
            <form onSubmit={this.handleSubmit} method="post">
              <div className="form-group">
                <input
                  type="text"
                  name="email"
                  ref={this.newEmailRef}
                  value={this.state.email}
                  onChange={this.handleChange}
                  className="form-control"
                  id="email"
                  placeholder="Enter your email"
                />
              </div>
              {this.state.showPasswordLogin && (
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={this.state.passwordVisible ? 'text' : 'password'}
                      name="password"
                      className="form-control"
                      id="password"
                      value={this.state.password}
                      onChange={this.handleChange}
                      placeholder="Enter your password"
                      autoComplete="off"
                      style={{ paddingRight: '2.5rem' }}
                    />
                    <span
                      className="password-toggle-icon"
                      onClick={() =>
                        this.setPasswordVisible(!this.state.setPasswordVisible)
                      }
                      style={{
                        position: 'absolute',
                        right: '0.5rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                      }}
                    >
                      {this.state.passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
              )}
              {this.state.showPasswordLogin && (
                <div className="form-group" style={{ textAlign: 'center' }}>
                  <button
                    className="btn btn-lg btn-primary btn-block btn-signin"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              )}
              {!this.state.showPasswordLogin && (
                <div className="form-group">
                  <button
                    className="btn btn-lg btn-primary btn-signin"
                    type="button"
                    onClick={this.handleMagicLinkRequest}
                    disabled={this.state.isMagicLinkLoading}
                    style={{ display: 'block', margin: '0' }}
                  >
                    {this.state.isMagicLinkLoading
                      ? 'Requesting Magic Link...'
                      : 'Request Magic Link'}
                  </button>
                </div>
              )}
              <p style={{ color: 'red', textAlign: 'center' }}>
                {this.errMsg !== 'Success' ? this.state.errMsg : null}
              </p>
              {this.state.magicLinkMessage && (
                <p
                  className={
                    this.state.magicLinkMessageType === 'success'
                      ? 'text-success'
                      : 'text-danger'
                  }
                >
                  {this.state.magicLinkMessage}
                </p>
              )}
            </form>
            {this.state.showPasswordLogin && (
              <div style={{ textAlign: 'center' }}>
                <Button
                  onClick={() => this.setForgotPasswordModal(true)}
                  className="forgot-password forgot-password-link"
                  color="link"
                  style={{ textDecoration: 'none', padding: 0 }}
                >
                  Forgot the password?
                </Button>
                <div>Or</div>
                <Button
                  type="button"
                  onClick={this.handlePasswordlessMode}
                  className="forgot-password-link"
                  color="link"
                  style={{ textDecoration: 'none', padding: 0 }}
                >
                  Login using Magic Link
                </Button>
              </div>
            )}
          </div>
        )}
        {this.state.forgotPasswordModal && (
          <LoginPasswordResetRequestForm
            reset_email={this.state.reset_email}
            handleChange={this.handleChange}
            handlePasswordResetRequest={this.handlePasswordResetRequest}
            forgotPasswordModal={this.state.forgotPasswordModal}
            setForgotPasswordModal={this.setForgotPasswordModal}
            handleResetModel={this.handleResetModel}
            alert={this.state.alert}
          />
        )}
        {this.state.resetPasswordModal && (
          <LoginResetPasswordForm
            reset_code={this.state.reset_code}
            reset_email={this.state.reset_email}
            new_password={this.state.new_password}
            confirm_password={this.state.confirm_password}
            handleChange={this.handleChange}
            handleResetPassword={this.handleResetPassword}
            resetPasswordModal={this.state.resetPasswordModal}
            setResetPasswordModal={this.setResetPasswordModal}
            handleResetModel={this.handleResetModel}
            alert={this.state.alert}
            newPassword={this.state.new_password}
            confirmPassword={this.state.confirm_password}
          />
        )}
        {this.state.forcePasswordChangeModal && (
          <LoginForcedPasswordChangeForm
            handleNewPasswordChallenge={this.handleNewPasswordChallenge}
            setForcePasswordChangeModal={this.setForcePasswordChangeModal}
            forcePasswordChangeModal={this.state.forcePasswordChangeModal}
            state={this.state}
            errorMessage={this.state.errorMessage}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            alert={this.state.alert}
            handleResetModel={this.handleResetModel}
          />
        )}
      </div>
    );
  }
}
export default Login;
